import HTTPEdition from '../HTTPEdition';

const BASE_URL_EDITION  = 'Edition/';
const BASE_URL_EXPORT = 'ExportExcel/'

export async function printAnonymeAsync(payload) {
  const config = {
    responseType: 'blob',
  };
  
  if (!payload.typeEdition || payload.typeEdition === '') {
    delete payload.typeEdition;
  }

  const response = await HTTPEdition.post(`${BASE_URL_EDITION}RecommandationAnonymePrintAsync`, payload, config);
  return response;
}

export async function exportAnonymeAsync(payload) {
  const config = {
    responseType: 'blob',
  };

  const response = await HTTPEdition.post(`${BASE_URL_EXPORT}RecommandationAnonymeExportAsync`, payload, config);
  return response;
}
